export default {
    indexIntegrationHours:     { method: 'get',    url: 'integration_hours' },
    storeIntegrationHour:      { method: 'post',   url: 'integration_hours' },
    updateIntegrationHour:     { method: 'put',    url: 'integration_hours/{id}'},
    destroyIntegrationHour:    { method: 'delete', url: 'integration_hours/{id}'},
}